// Playback-time ↔ alphaTab-tick mapping over the chart's measures. Pure given the chart measures
// + their stamped tick spans. Ported from poc/web/app.js tickForTime/timeForTick.

import type { ChartMeasure } from "../types/domain";
import type { TickSpan } from "./notation/alphaTex";

// merge a tickMap into chartMeasures so they carry startTick/durTick (matches the PoC's stamping)
export function applyTickMap(measures: ChartMeasure[], tickMap: TickSpan[]): ChartMeasure[] {
  return measures.map((m, i) => ({ ...m, startTick: tickMap[i]?.startTick ?? 0, durTick: tickMap[i]?.durTick ?? 3840 }));
}

// map a playback time (s) → chart tick. Used to align song & score and to move the cursor in song mode.
export function tickForTime(measures: ChartMeasure[], t: number): number {
  let m = -1;
  for (let i = 0; i < measures.length; i++) {
    if (t >= measures[i].startTime - 0.05) m = i; else break;
  }
  if (m < 0) return 0;
  const mm = measures[m];
  const span = (mm.endTime - mm.startTime) || 0.001;
  const frac = Math.max(0, Math.min(1, (t - mm.startTime) / span));
  return Math.round((mm.startTick || 0) + frac * (mm.durTick || 3840));
}

// inverse: a chart tick → the song time it corresponds to.
export function timeForTick(measures: ChartMeasure[], tick: number): number {
  let m = -1;
  for (let i = 0; i < measures.length; i++) {
    if (tick >= (measures[i].startTick || 0)) m = i; else break;
  }
  if (m < 0) return 0;
  const mm = measures[m];
  const frac = mm.durTick ? Math.max(0, Math.min(1, (tick - (mm.startTick || 0)) / mm.durTick)) : 0;
  return mm.startTime + frac * ((mm.endTime - mm.startTime) || 0);
}
